export default {
  root      : 'carousel',
  slider    : `carousel_slider`,
  track     : `carousel_track`,
  list      : `carousel_list`,
  slide     : `carousel_slide`,
  container : `carousel_slide_container`,
  arrows    : `carousel_arrows`,
  arrow     : `carousel_arrow`,
  prev      : `carousel_arrow_prev`,
  next      : `carousel_arrow_next`,
  pagination: `carousel_pagination`,
  page      : `carousel_pagination_page`,
  clone     : `carousel_slide_clone`,
  progress  : `carousel_progress`,
  bar       : `carousel_progress_bar`,
  autoplay  : `carousel_autoplay`,
  play      : `carousel_play`,
  pause     : `carousel_pause`,
  spinner   : `carousel_spinner`,
  sr        : `carousel_sr`
};
